import React, { createContext, useState, ReactNode } from 'react';
import LoadingBar from '../components/LoadingBar/LoadingBar';

// Define the context shape
export interface LoadingBarContextProps {
    show: (id?: string) => void;
    hide: (id?: string) => void;
}

// Create the context with an undefined initial value
export const LoadingBarContext = createContext<LoadingBarContextProps | undefined>(undefined);

// Create a provider component
export const LoadingBarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [loadingBarVisible, setLoadingBarVisible] = useState<boolean>(false);
    const [loadingIds, setLoadingIds] = useState<Set<string>>(new Set());

    const show = (id?: string) => {
        if (id) {
            setLoadingIds(prevIds => new Set(prevIds).add(id));
        } else {
            setLoadingBarVisible(true);
        }
    };

    const hide = (id?: string) => {
        if (id) {
            setLoadingIds(prevIds => {
                const newIds = new Set(prevIds);
                newIds.delete(id);
                return newIds;
            });
        } else {
            setLoadingBarVisible(false);
        }
    };

    const isLoading = loadingBarVisible || loadingIds.size > 0;

    return (
        <LoadingBarContext.Provider
            value={{
                show,
                hide
            }}
        >
            {isLoading && <LoadingBar />}
            {children}
        </LoadingBarContext.Provider>
    );
};
